import React from 'react';

const BlogCard = ({ post }) => {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-md transition hover:shadow-lg">
      <a
        href={post.href}
        className="flex flex-1 flex-col focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="aspect-[16/10] overflow-hidden bg-[#f7f5f2]">
          <img
            src={post.image}
            alt={post.imageAlt}
            className="h-full w-full object-cover transition duration-300 group-hover:scale-[1.02]"
            loading="lazy"
          />
        </div>
        <div className="flex flex-1 flex-col p-5 md:p-6">
          <p className="mb-2 text-xs font-medium uppercase tracking-wide text-accent">
            {post.publishedDate}
          </p>
          <h3 className="mb-3 text-lg font-semibold leading-snug text-primary transition group-hover:text-accent md:text-xl">
            {post.title}
          </h3>
          <p className="mb-4 flex-1 text-sm leading-relaxed text-gray-700 md:text-base">
            {post.excerpt}
          </p>
          <span className="text-sm font-semibold text-accent group-hover:underline">
            Read article →
          </span>
        </div>
      </a>
    </article>
  );
};

export default BlogCard;
